<template>
  <div>
    <section class="sub-banner01 banner-top02 position-relative float-start w-100">
      <TitAndBread></TitAndBread>
    </section>
    <main class="float-start w-100">
      <section class="contact-us-page d-inline-block w-100 my-5">
        <div class="container">
          <div class="container">
            <div class="row g-lg-5">
              <div class="col-lg-5 col-xl-4">
                <div class="cm-text-n">
                  <h6 class="mb-0">联系我们</h6>
                  <h2 class="main-head-text"> 欢迎您来电咨询 </h2>
                  <ul class="list-unstyled mt-4">
                    <li class="d-flex">
                      <span class="icon-c"><i class="fas fa-phone-square-alt"></i></span>
                      <span class="text-c"> 电话
                        <small class="d-block"> 400-833-9068</small>
                      </span>
                    </li>
                    <li class="d-flex">
                      <span class="icon-c"><i class="fas fa-envelope"></i></span>
                      <span class="text-c">
                        邮箱:
                        <small class="d-block"> admin@jero168.com </small>
                      </span>
                    </li>
                    <li class="d-flex">
                      <span class="icon-c"><i class="fas fa-map-marker-alt"></i></span>
                      <span class="text-c"> 地址:
                        <small class="d-block"> 重庆市北部新区土星C3座22-3</small>
                      </span>
                    </li>
                  </ul>
                </div>
              </div>
              <div class="col-lg-7 col-xl-8">
                <div class="conatct-form-div mb-5 mt-5 mt-lg-0">
                  <h6 class="mb-0 subt-text">给我们留言</h6>
                  <h2 class="text-white main-head-text"> 请填写信息（暂未开放） </h2>
                  <el-form ref="form" :model="form" :rules="rules" label-width="0px">
                    <div class="row mt-4">
                      <div class="col-lg-6">
                        <el-form-item>
                          <input disabled type="text" v-model="form.name" class="form-control" placeholder="名称">
                        </el-form-item>
                      </div>
                      <div class="col-lg-6">
                        <el-form-item>
                          <input disabled type="email" v-model="form.email" class="form-control" placeholder="邮箱">
                        </el-form-item>
                      </div>
                      <div class="col-lg-6">
                        <el-form-item>
                          <input disabled type="text" v-model="form.phone" class="form-control" placeholder="电话">
                        </el-form-item>
                      </div>
                      <div class="col-lg-6">
                        <el-form-item>
                          <input disabled type="text" v-model="form.subject" class="form-control" placeholder="项目名称">
                        </el-form-item>
                      </div>
                      <div class="col-lg-12">
                        <el-form-item>
                          <textarea disabled class="form-control" v-model="form.message" placeholder="内容描述"></textarea>
                        </el-form-item>
                      </div>
                      <div class="col-lg-12">
                        <el-button @click="submit" class="btn subimt-message btnLinH" :loading="isLoading">提交</el-button>
                      </div>
                    </div>
                  </el-form>
                </div>
              </div>
            </div>

          </div>
        </div>
      </section>
    </main>
  </div>
</template>

<script>
import TitAndBread from '@/components/TitAndBread';
import FooterHint from '@/components/FooterHint';
export default {
  name: '',
  components: { TitAndBread, FooterHint },
  props: {},
  data() {
    return {
      form: {
        name: '',
        email: '',
        phone: '',
        subject: '',
        message: '',
      },
      rules: {
        name: [
          { required: true, message: '请输入用户名', trigger: 'blur' },
        ],
        email: [
          { required: true, message: '请输入邮箱地址', trigger: 'blur' },
          { type: 'email', message: '请输入正确的邮箱地址', trigger: ['blur', 'change'] }
        ],
        phone: [
          { required: true, message: '请输入电话', trigger: 'blur' },
        ],
        subject: [
          { required: true, message: '请输入项目名称', trigger: 'blur' },
        ],
        message: [{ required: true, message: '请输入内容描述', trigger: 'blur' }],
      },
      isLoading: false,
    }
  },
  computed: {},
  watch: {},
  created() { },
  mounted() { },
  methods: {
    submit() {
      this.$message( "暂未开放")
      // this.$refs.form.validate((valid) => {
      //   if (valid) {
      //     // 调接口
      //     this.isLoading = true;
      //     this.$refs.form.resetFields();
      //   }
      // })
    }
  }
}
</script>

<style scoped lang="less">
.form-control {
  margin-bottom: 0 !important;
}
.btnLinH {
  line-height: 24px;
}
</style>
